import GlobalsApi from '../../api/Globals';

// initial state
const stateApp = {
    isMobile: (window.innerWidth < 1024),
    smallDesktop: (window.innerWidth < 1600),
    mybetsModalOpen: false,
    lastSelectedTicketOnline: null,
    canPlaceOnlineTicket: false,
    maintenance: {},
    showHelpOnPages: {
        lotto: true,
        sport: true,
        horses: true,
    },
};

window.addEventListener('resize', () =>
{
    if (window.innerWidth < 1024)
    {
        stateApp.isMobile = true;
    }
    else
    {
        stateApp.isMobile = false;
    }

    if (window.innerWidth < 1600)
    {
        stateApp.smallDesktop = true;
    }
    else
    {
        stateApp.smallDesktop = false;
    }
});

let showHelpOnPages = null;

try
{
    showHelpOnPages = JSON.parse(
        window.localStorage.getItem(
            'showHelpOnPages',
        ),
    );
}
catch (e)
{
    // fall silently
    showHelpOnPages = {
        sport: false,
        lotto: false,
        horses: false,
    };
}

try
{
    for (const pageKey in showHelpOnPages)
    {
        if (showHelpOnPages[pageKey] != null)
        {
            stateApp.showHelpOnPages[pageKey] = showHelpOnPages[pageKey];
        }
    }

    window.localStorage.setItem(
        'showHelpOnPages',
        JSON.stringify(stateApp.showHelpOnPages),
    );
}
catch (e)
{
    // fall silently
}

// getters
const getters = {
    isMobile: (state) => state.isMobile,
    smallDesktop: (state) => state.smallDesktop,
    mybetsModalOpen: (state) => state.mybetsModalOpen,
    lastSelectedTicketOnline: (state) => state.lastSelectedTicketOnline,
    canPlaceOnlineTicket: (state) => state.canPlaceOnlineTicket,
    maintenance: (state) => state.maintenance,
    showHelpOnPages: (state) => state.showHelpOnPages,
};

// actions
const actions = {
    async getTranslationByLangCode(context, data)
    {
        const translation = await GlobalsApi.getTranslationByLangCode(data.langCode);
        if (data.langCode !== context.rootState.globals.globals.langCode
        && (data.reloadGlobals == null || data.reloadGlobals === true))
        {
            context.dispatch('reloadGlobals');
        }

        context.commit('receiveLanguage', { translation });
    },
    toggleMybetsModal(context, data)
    {
        context.commit('toggleMybetsModal', data);
    },
    setLastSelectedTicketOnline(context, data)
    {
        context.commit('setLastSelectedTicketOnline', data);
    },
    changeCanPlaceOnlineTicket(context, data)
    {
        context.commit('changeCanPlaceOnlineTicket', data);
    },
    async payouttoonline(context, data)
    {
        const response = await GlobalsApi.payoutToOnlineAccount(data);

        return response;
    },
    setMaintenance(context)
    {
        if (context.rootState.globals
            && context.rootState.globals.globals
            && context.rootState.globals.globals.publicConfig
            && context.rootState.globals.globals.publicConfig.maintenance)
        {
            const { maintenance } = context.rootState.globals.globals.publicConfig;

            const mnt = {};

            if (maintenance.live)
            {
                mnt.live = true;
            }
            else
            {
                mnt.live = false;
            }

            if (maintenance.prematch)
            {
                mnt.prematch = true;
            }
            else
            {
                mnt.prematch = false;
            }

            if (maintenance.lotto)
            {
                mnt.lotto = true;
            }
            else
            {
                mnt.lotto = false;
            }

            if (maintenance.vhorse)
            {
                mnt.vhorse = true;
            }
            else
            {
                mnt.vhorse = false;
            }

            context.commit('setMaintenance', mnt);
        }
    },
    setPageHelpDisplayed(context, page)
    {
        context.commit('setPageHelpDisplayed', page);
    },
};

// mutations
const mutations = {
    toggleMybetsModal(state, data)
    {
        if (data !== undefined)
        {
            state.mybetsModalOpen = data;
        }
        else
        {
            state.mybetsModalOpen = !state.mybetsModalOpen;
        }
    },
    setLastSelectedTicketOnline(state, data)
    {
        state.lastSelectedTicketOnline = data;
    },
    changeCanPlaceOnlineTicket(state, data)
    {
        state.canPlaceOnlineTicket = data;
    },
    setMaintenance(state, data)
    {
        // eslint-disable-next-line prefer-object-spread
        state.maintenance = Object.assign({}, data);
    },
    setPageHelpDisplayed(state, page)
    {
        if (state.showHelpOnPages[page])
        {
            state.showHelpOnPages[page] = false;

            try
            {
                window.localStorage.setItem(
                    'showHelpOnPages',
                    JSON.stringify(state.showHelpOnPages),
                );
            }
            catch (e)
            {
                // fall silently
            }
        }
    },
};

export default
{
    state: stateApp,
    getters,
    actions,
    mutations,
};
